import { useContext, useState } from 'react';
import '../css/user/adduser.css'; // Assuming you use the same CSS file for modal styling
import { Dimcontext } from '../../context/pagecontext';
import { Button, Form, FormControl, FormGroup, FormLabel, Row, Col } from 'react-bootstrap';
import { MdClose, MdDomain, MdLocationOn, MdAccessTime, MdSettingsInputAntenna } from 'react-icons/md';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import api from '../../api';
import Swal from 'sweetalert2';
import { ToastContainer } from 'react-toastify';

export const AddBranch = ({ set_add, showToast, fetchBranches }) => {
    const { setDim } = useContext(Dimcontext);
    const [bt, setBt] = useState(false);
    
    // Branch State Initialized
    const [branchData, setBranchData] = useState({
        name: "", 
        lattitude: "", 
        longitude: "", 
        radius: "", 
        geofence: "enable", 
        shift: "1"
    });

    const handleaddclose = () => {
        setDim(false);
        set_add(false);
    };

    const add = async (e) => {
        e.preventDefault();
        setBt(true);

        try {
            // Ensure numbers are properly formatted before sending if needed, 
            // though keeping them as strings is fine if your Joi validation handles it
            const finalData = {
                ...branchData,
                name: branchData.name.trim(),
                lattitude: parseFloat(branchData.lattitude) || 0,
                longitude: parseFloat(branchData.longitude) || 0,
                radius: parseInt(branchData.radius) || 0,
            };

            // Post to your branch API endpoint (adjust URL if needed)
            await api.post('/add_newbranch', finalData);
            
            Swal.fire({
                title: "Branch Created!",
                text: "The new branch has been successfully saved.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            handleaddclose();
            if (fetchBranches) fetchBranches(); // Refresh the table data
            
        } catch (error) { 
        console.error("Branch Error:", error); 
        
        // 1. Safely extract the data payload from Axios
        const errData = error.response?.data;

        // 2. Check for Joi's specific 'details' array first, then fall back to standard messages
        const errorMessage = 
            errData?.details?.[0]?.message || // Handles raw Joi errors
            errData?.message ||               // Handles standard formatted backend errors
            errData?.error ||                 // Handles alternative formatting
            "Failed to process branch request"; // Final fallback

        // 3. Clean up the message (Joi puts ugly double quotes around field names like '"lattitude"')
        const cleanMessage = errorMessage.replace(/"/g, '');

        showToast(cleanMessage);
        
    } finally {
        setBt(false); // or setIsSubmitting(false) for edit
    }
    };

    return (
        <div className='adduser-card shadow-lg'>
            <ToastContainer/>
            <div className="modal-header-custom">
                <div className="header-title">
                    <MdDomain className="me-2" />
                    <span>Create New Branch</span>
                </div>
                <button onClick={handleaddclose} className='btn-close-custom'><MdClose /></button>
            </div>

            <SimpleBar style={{ width: '100%', height: 'calc(80vh - 70px)' }} noScrollX>
                <Form onSubmit={add} className="p-4">
                    
                    {/* Section: Basic Details */}
                    <div className="form-section">
                        <h6 className="section-title"><MdDomain className="me-2"/>Basic Information</h6>
                        <Row className="g-3">
                            <Col md={12}>
                                <FormGroup>
                                    <FormLabel>Branch Name</FormLabel>
                                    <FormControl 
                                        required 
                                        type='text' 
                                        value={branchData.name} 
                                        onChange={(e) => setBranchData({ ...branchData, name: e.target.value })} 
                                        placeholder='Enter branch name (Any characters allowed)' 
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    {/* Section: Location & Geofence Details */}
                    <div className="form-section mt-4">
                        <h6 className="section-title"><MdLocationOn className="me-2"/>Location Settings</h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Lattitude</FormLabel>
                                    <FormControl 
                                        required 
                                        type='text' 
                                        value={branchData.lattitude} 
                                        // Regex allows only numbers and periods (added optional minus sign for valid coordinates)
                                        onChange={(e) => setBranchData({ ...branchData, lattitude: e.target.value.replace(/[^0-9.-]/g, "") })} 
                                        placeholder='e.g., 12.9716' 
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Longitude</FormLabel>
                                    <FormControl 
                                        required 
                                        type='text' 
                                        value={branchData.longitude} 
                                        // Regex allows only numbers and periods (and minus signs)
                                        onChange={(e) => setBranchData({ ...branchData, longitude: e.target.value.replace(/[^0-9.-]/g, "") })} 
                                        placeholder='e.g., 77.5946' 
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <FormLabel>Radius (in meters)</FormLabel>
                                    <FormControl 
    required 
    type='text' 
    maxLength={3} // Prevents the user from typing more than 3 characters
    value={branchData.radius} 
    onChange={(e) => setBranchData({ 
        ...branchData, 
        // Replaces non-digits and slices the string to a maximum of 3 characters
        radius: e.target.value.replace(/\D/g, "").slice(0, 3) 
    })} 
    placeholder='e.g., 500' 
/>
                                </FormGroup>
                            </Col>

                            <Col md={12}>
                                <FormGroup className="doc-collect-box mt-2">
                                    <FormLabel className="me-4 fw-bold mb-0"><MdSettingsInputAntenna className="me-1"/> Geofencing</FormLabel>
                                    <Form.Check 
                                        inline type="radio" label="Enable" name='geofence' value='enable' 
                                        onChange={(e) => setBranchData({ ...branchData, geofence: e.target.value })} 
                                        checked={branchData.geofence === 'enable'} 
                                    />
                                    <Form.Check 
                                        inline type="radio" label="Disable" name='geofence' value='disable' 
                                        onChange={(e) => setBranchData({ ...branchData, geofence: e.target.value })} 
                                        checked={branchData.geofence === 'disable'} 
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup className="doc-collect-box mt-2">
                                    <FormLabel className="me-4 fw-bold mb-0"><MdAccessTime className="me-1"/> Shift Schedule</FormLabel>
                                    <Form.Check 
                                        inline type="radio" label="Shift 1" name='shift' value='1' 
                                        onChange={(e) => setBranchData({ ...branchData, shift: e.target.value })} 
                                        checked={branchData.shift === '1'} 
                                    />
                                    <Form.Check 
                                        inline type="radio" label="Shift 2" name='shift' value='2' 
                                        onChange={(e) => setBranchData({ ...branchData, shift: e.target.value })} 
                                        checked={branchData.shift === '2'} 
                                    />
                                    <Form.Check 
                                        inline type="radio" label="Shift 3" name='shift' value='3' 
                                        onChange={(e) => setBranchData({ ...branchData, shift: e.target.value })} 
                                        checked={branchData.shift === '3'} 
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    <div className="footer-actions mt-4">
                        <Button variant="secondary" className="px-4" onClick={handleaddclose}>Cancel</Button>
                        <Button type='submit' className="btn-submit px-5" disabled={bt}>Save Branch</Button>
                    </div>
                </Form>
            </SimpleBar>
        </div>
    );
};